import { render, staticRenderFns } from "./DialogContainer.vue?vue&type=template&id=5b651944&scoped=true&"
import script from "./DialogContainer.vue?vue&type=script&lang=js&"
export * from "./DialogContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b651944",
  null
  
)

export default component.exports